import {createHashRouter, Navigate, RouterProvider} from "react-router-dom";
import {Layout} from "./components/Layout.tsx";
import {ImportPage} from "./features/import";
import {ShiftListPage} from "./features/shift/ShiftListPage.tsx";
import {ShiftPage} from "./features/shift/ShiftPage.tsx";
import { ConfigPage } from "./features/config";
import {AboutPage} from "./features/config/about/AboutPage.tsx";

const router = createHashRouter([
    {
        path: "",
        element: <Layout/>,
        children: [
            {
                path: "/",
                element: <Navigate to={"shift"} replace/>
            },
            {
                path: "config",
                element: <ConfigPage/>
            },
            {
                path: "about",
                element: <AboutPage/>
            },
            {
                path: "import",
                element: <ImportPage/>
            },
            {
                path: "shift",
                element: <ShiftListPage/>
            },
            {
                path: "shift/:id",
                element: <ShiftPage/>
            }
        ]
    }

])

export function Router() {
    return (
        <>
            <RouterProvider router={router}></RouterProvider>
        </>
    )
}

